import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import BasicDialog from '@zenbusiness/zui/BasicDialog';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './DisclaimerModal.styles';

export const LOCALIZED_TEXT = {
  title: 'dashboard.carousel.card.smsOptIn.disclaimer.title',
  subtitle: 'dashboard.carousel.card.smsOptIn.disclaimer.subTitle',
  line1: 'dashboard.carousel.card.smsOptIn.disclaimer.line1',
  line2: 'dashboard.carousel.card.smsOptIn.disclaimer.line2',
  line3: 'dashboard.carousel.card.smsOptIn.disclaimer.line3',
  link1: 'dashboard.carousel.card.smsOptIn.disclaimer.link1',
  link2: 'dashboard.carousel.card.smsOptIn.disclaimer.link2',
  closeButton: 'dashboard.carousel.card.smsOptIn.disclaimer.button.close',
};

function DisclaimerModal({ onClose }) {
  const { formatMessage: fm } = useIntl();

  return (
    <BasicDialog
      open
      subtitle={fm({ id: LOCALIZED_TEXT.subtitle })}
      title={fm({ id: LOCALIZED_TEXT.title })}
      secondaryAction={{
        autoFocus: true,
        clickstreamProps: {
          appSection: 'home',
          elementName: 'opt_in_disclaimer_close_button',
        },
        label: fm({ id: LOCALIZED_TEXT.closeButton }),
        onClick: onClose,
      }}
    >
      <Stack spacing={{ xs: 2, md: 3 }}>
        <Text size="md">
          <FormattedMessage id={LOCALIZED_TEXT.line1} />
        </Text>
        <Text size="md">
          <FormattedMessage id={LOCALIZED_TEXT.line2} />
          &nbsp;
          <Styled.Link component="span">
            <FormattedMessage id={LOCALIZED_TEXT.link1} />
          </Styled.Link>
          &nbsp;
          <FormattedMessage id={LOCALIZED_TEXT.line3} />
          &nbsp;
          <Styled.Link component="span">
            <FormattedMessage id={LOCALIZED_TEXT.link2} />
          </Styled.Link>
          .
        </Text>
      </Stack>
    </BasicDialog>
  );
}

DisclaimerModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default DisclaimerModal;
